import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const GOLD = "#c9a227";
const STORAGE_KEY = "trs_cookie_consent_v1";

// Hide on print/funnel-only pages where a banner would hurt conversion or break PDF capture.
const HIDDEN_ROUTES = [
    "/live",
    "/watch",
    "/sleep",
    "/plan",
    "/session",
    "/investors",
    "/dapperdan",
    "/brochure",
    "/brochure-corporate",
    "/brochure-gym",
    "/brochure-realestate",
    "/brochure-athletes",
    "/brochure-equine",
    "/brochure-pets",
    "/brochure-yacht",
    "/brochure-bvlgari",
    "/thank-you",
    "/resume",
    "/cover-letter",
    "/application",
    "/cover-letter-portable",
    "/application-portable",
    "/cover-letter-wynn",
    "/application-wynn",
    "/application-wynn-stage",
    "/application-wynn-automation",
    "/application-tether",
    "/reel",
];

const CookieConsent = () => {
    const { pathname } = useLocation();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (HIDDEN_ROUTES.includes(pathname)) {
            setVisible(false);
            return;
        }
        try {
            const stored = localStorage.getItem(STORAGE_KEY);
            if (!stored) setVisible(true);
        } catch (e) {
            setVisible(true);
        }
    }, [pathname]);

    const accept = () => {
        try {
            localStorage.setItem(
                STORAGE_KEY,
                JSON.stringify({ status: "accepted", ts: Date.now() })
            );
        } catch (e) {
            // ignore
        }
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div
            data-testid="cookie-consent-banner"
            role="dialog"
            aria-live="polite"
            aria-label="Cookie consent"
            style={{
                position: "fixed",
                left: 16,
                right: 16,
                bottom: 16,
                zIndex: 9999,
                backgroundColor: "rgba(15,15,15,0.97)",
                border: "1px solid rgba(201,162,39,0.25)",
                borderRadius: 12,
                boxShadow: "0 12px 32px rgba(0,0,0,0.45)",
                backdropFilter: "blur(12px)",
                WebkitBackdropFilter: "blur(12px)",
                padding: "16px 20px",
                color: "#ddd",
                fontSize: 13,
                lineHeight: 1.6,
                fontWeight: 300,
                maxWidth: 920,
                margin: "0 auto",
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 14,
            }}
        >
            <p style={{ margin: 0, flex: "1 1 320px", color: "#bbb" }}>
                We use essential cookies plus the{" "}
                <span style={{ color: "#fff" }}>Meta Pixel</span> to measure ad
                performance and improve your experience. By continuing you
                accept this.{" "}
                <Link
                    to="/privacy"
                    style={{
                        color: GOLD,
                        textDecoration: "underline",
                        textUnderlineOffset: 2,
                    }}
                    data-testid="cookie-consent-privacy-link"
                >
                    Privacy Policy
                </Link>
                .
            </p>
            <button
                type="button"
                onClick={accept}
                data-testid="cookie-consent-accept"
                style={{
                    backgroundColor: GOLD,
                    color: "#0a0a0a",
                    border: "none",
                    padding: "10px 22px",
                    fontSize: 12,
                    fontWeight: 600,
                    letterSpacing: "0.12em",
                    textTransform: "uppercase",
                    borderRadius: 999,
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                    flexShrink: 0,
                }}
            >
                Accept
            </button>
        </div>
    );
};

export default CookieConsent;
